import axios from 'axios';
import { saveAs } from 'file-saver';

const cloneObject = (srcObj: any): any => {
  return JSON.parse(JSON.stringify(srcObj));
};

const downloadFile = (data: string | Blob, filename?: string): void => {
  saveAs(data, filename);
};

const getFileName = (contentDisposition: string): string | undefined => {
  let fileName = '';

  if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    let matches = filenameRegex.exec(contentDisposition);
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '');
    }

    return fileName;
  }
};

const downloadFileAPI = (
  endpoint: string,
  errorHandler: any,
  errorMessage?: string,
  config?: any,
  finallyCallback: VoidFunction = () => {},
) => {
  axios
    .get(endpoint, {
      responseType: 'blob',
      ...config,
    })
    .then((response: any) => {
      downloadFile(response.data, getFileName(response.headers['content-disposition']));
    })
    .catch(async (error) => {
      try {
        const text = await error.response.data.text();
        if (text) {
          error.response.data = JSON.parse(text);
        }
      } finally {
        errorHandler(error, errorMessage);
      }
    })
    .finally(() => finallyCallback());
};

const AppHelper: { [key: string]: any } = {
  cloneObject: cloneObject,
  downloadFile: downloadFile,
  downloadFileAPI: downloadFileAPI,
};

export default AppHelper;
